import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: 'img[appFallbackSrc]',
  standalone: false,
})
export class ImgFallbackDirective {
  @Input() appFallbackSrc: string = '';

  @HostListener('error', ['$event.target'])
  onError(img: HTMLImageElement) {
    img.src = this.appFallbackSrc;
  }
}
